import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-tab-more-popover',
  template: `
    <ion-list>
      <ion-list-header>Menu</ion-list-header>
      <ion-item button (click)="onLogoutClick()">Logout</ion-item>
    </ion-list>
  `,
})
export class TabsMorePopoverComponent {
  constructor(private router: Router, private popoverCtrl: PopoverController) {}
  onLogoutClick() {
    this.popoverCtrl.dismiss();
    this.router.navigate(['/']);
  }
}